import { Panel } from '@studiometa/ui';

/**
 * PanelInfo component
 */
export default class PanelInfo extends Panel {
  /**
   * Component Configuration
   */
  static config = {
    name: 'PanelInfo',
  };

  /**
   * Open panel
   * @param {string} param Modal content id
   */
  async open(param) {
    super.open();

    const content = document.querySelector(`#modal-content-${param}`);
    this.$refs.content.innerHTML = content.innerHTML;
  }

  /**
   *
   */
  async close() {
    super.close();
    this.$refs.content.innerHTML = '';
  }
}
